import React from 'react';
import TemplateParametro from '../shared/templateParametros/templateParametros';
import EmpreendimentosExcluidosService from '../../../../lib/api/empreendimentosExcluidos/empreendimentosExcluidos';

class ParametroEmpreendimentosExcluidos extends React.Component<{}, {}> {
    constructor(props: any) {
        super(props);
        this.state = {};
    }

    baixarParametrosExcel() {
        return EmpreendimentosExcluidosService.baixarParametrosExcel();
    }

    reenviarParametrosExcel() {
        return EmpreendimentosExcluidosService.reenviarParametrosExcel();
    }

    render() {
        return (
            <TemplateParametro
                enviarParametrosEventGrid={this.reenviarParametrosExcel}
                baixarExcelParametros={this.baixarParametrosExcel}
                enviarExcelParametros={EmpreendimentosExcluidosService.salvarParametrosExcel}
                deletarExcelParametros={EmpreendimentosExcluidosService.deletarParametrosExcel}
                nomeDoArquivo='Parametro Empreendimentos Excluidos'
            />
        );
    }
}

export default ParametroEmpreendimentosExcluidos;
